import { Link, useNavigate  } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removeFromCart, updateQuantity } from "../../app/config/redux/slices/cartSlice";
import { IMAGE_URL } from "../../constants";


const Product = ({ product, buttons, cartQuantity }) => {

    const cartItem = useSelector((state) =>
        state.cart.cartItems.find((item) => item.product.id == product.id)
    );

    const dispatch = useDispatch();
    const navigate = useNavigate();

    return (
                <div className="product-card h-100 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                    <Link
                        to={`/product-details/${product.slug}`}
                        className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                    >
                <img
                    src={
                        product.image_url
                            ? product.image_url
                            : product.image
                                ? `${IMAGE_URL}/${product.image}`
                                : "/assets/images/thumbs/product-two-img1.png"
                    }
                    srcSet={product.image_srcset || undefined}
                    sizes="(max-width: 576px) 400px,
                        (max-width: 992px) 800px,
                        1200px"
                    alt={product.name}
                    loading="lazy"
                />
                        {/* <span className="product-card__badge bg-primary-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                            Best Sale{" "}
                        </span> */}
                    </Link>
                    <div className="product-card__content p-16">
                        <h6 className="title text-lg fw-semibold mt-5 mb-8">
                            <Link
                                to={`/product-details/${product.slug}`}
                                className="link text-line-2"
                                tabIndex={0}
                            >
                               {product.name}
                            </Link>
                        </h6>
                        <span className="text-main-800 text-xs fw-medium mt-8">
                                by {product.user?.name}
                        </span>
                        {/* <div className="flex-align mb-20 mt-16 gap-6">
                            <span className="text-xs fw-medium text-gray-500">4.8</span>
                            <span className="text-15 fw-medium text-warning-600 d-flex">
                                <i className="ph-fill ph-star" />
                            </span>
                            <span className="text-xs fw-medium text-gray-500">(17k)</span>
                        </div> */}
                        <div className="mt-8">
                            <div
                                className="progress w-100 bg-color-three rounded-pill h-4"
                                role="progressbar"
                                aria-label="Basic example"
                                aria-valuenow={35}
                                aria-valuemin={0}
                                aria-valuemax={100}
                            >
                                <div
                                    className="progress-bar bg-main-two-600 rounded-pill"
                                    style={{ width: `${(product.quantity / 100) * 100}%` }}
                                />
                            </div>
                            <span className="text-gray-900 text-xs fw-medium mt-8">
                                Stock left : {Number(product.quantity)}
                            </span>
                        </div>
                        <div className="product-card__price my-10 d-flex align-items-center justify-content-between">

                            {/* LEFT SIDE */}
                            <div className="d-flex align-items-center gap-2">
                                <span className="text-heading text-md fw-semibold">
                                    ₹{product.price - (product.price / 100) * product.discount}
                                </span>

                                {product.discount > 0 && (
                                    <span className="text-gray-400 text-xs text-decoration-line-through">
                                        {Math.round(product.price)}
                                    </span>
                                )}
                            </div>

                            {/* RIGHT SIDE */}
                            {product.discount > 0 && (
                                <span className="text-warning-600 text-sm fw-semibold">
                                   -{Math.round(product.discount)}% Off
                                </span>
                            )}

                        </div>
                        <button
                            onClick={() => {
                                if (cartItem) {
                                    navigate("/cart");
                                } else {
                                    dispatch(addToCart({ product }));
                                }
                            }}
                            className="product-card__cart btn py-11 px-24 rounded-8 flex-center gap-8 fw-medium w-100
                                bg-main-600 text-white hover-bg-main-700 hover-text-white"
                            tabIndex={0}
                        >
                            {cartItem ? "View in Cart" : "Add To Cart"} 
                            <i className="ph ph-shopping-cart" />
                        </button>
                    </div>
                </div>
    );
}

export default Product;

